import React, { useEffect, useRef, useState } from 'react';

import KitchenScene from '../game/KitchenScene';
import MyPlateScene from '../game/MyPlateScene';


//import logoImg from "../logo.svg";
import Phaser from 'phaser';
//import { SpinePlugin } from '@esotericsoftware/spine-phaser';
import '../../node_modules/phaser/plugins/spine4.1/dist/SpinePlugin';
import { Grid, IconButton, Popper } from '@mui/material';

import CustomIconButton from '../game/CustomIconButton';

import closeBtn from '../media/1x/02_button/button_close_outline-min.png';


// import step all step images (1-8) from path src/media/2x/03_steps/step_1.png
import stepBackgroundFirst from '../media/2x/03_steps/nav_off_left_2x-min.png';
import stepBackgroundMiddle from '../media/2x/03_steps/nav_off_center_2x-min.png';
import stepBackgroundLast from '../media/2x/03_steps/nav_off_right_2x-min.png';

import stepBackgroundOnFirst from '../media/2x/03_steps/nav_on_left_2x-min.png';
import stepBackgroundOnMiddle from '../media/2x/03_steps/nav_on_center_2x-min.png';
import stepBackgroundOnLast from '../media/2x/03_steps/nav_on_right_2x-min.png';


import leftNavBtn from '../media/2x/02_button/button_arrow_left_2x-min.png';
import rightNavBtn from '../media/2x/02_button/button_arrow_right_2x-min.png';

import CustomAudioPlayer from '../game/CustomAudioPlayer';
import CookingScene from '../game/CookingScene';

import CrossfadeImage from 'react-crossfade-image';


import SlidingGrid from './SlidingGrid';

const INIT_LEVEL = 0;//0 = cooking, 1 = myplate
const INIT_STEP = 0;
const PHASER_SCENES = [KitchenScene,CookingScene,MyPlateScene];//Phaser will start with the first scene in the array

/**
 * Converts a Google Drive URL to a direct download link.
 * @param {string} url - The Google Drive URL to convert.
 * @returns {string|null} - The direct download link if the conversion is successful, or null if the URL is invalid.
 */
function convertToDirectLink(url) {
    if (url == null)
        return null;

    //if it starts with '/' then it is a relative path and we need to add the base url
    if (String(url).startsWith('/')) {
        url = process.env.PUBLIC_URL + url;
        return url;
    }

    const match = url.match(/\/d\/(.+?)\//);

    if (match && match.length > 1) {
        return `https://drive.google.com/uc?export=view&id=${match[1]}`;
    }
    return null; // or you can return the original URL or handle this case as you prefer
}

// Helper function to convert CSV to an array of URLs
const parseCSV = (csv) => {
    if(!csv) return [];

    if (Array.isArray(csv)) return csv;

    return csv.split(',').map(url => url.trim());
};

// left bar image gallery
const SLIDE_DURATION = 3000;
const ImageGallery = ({ link, urls, captions }) => {

    let urlsParsed = parseCSV(urls);
    let captionsParsed = parseCSV(captions);
    let [currentIndex, setCurrentIndex] = useState(0);

    //remove duplicates from urls
    let uniqueUrls = [...new Set(urlsParsed)];


    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % uniqueUrls.length);
        }, SLIDE_DURATION); // Change image every 2 seconds

        return () => clearInterval(interval);
    }, [uniqueUrls.length]);

    return (
        <>
            {/* {JSON.stringify(uniqueUrls)} */}
            {uniqueUrls.length === 1 && (
                <div>
                    {link ? (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img src={convertToDirectLink(uniqueUrls[0])} alt="Gallery Item" />
                        </a>
                    ) : (
                        <img src={convertToDirectLink(uniqueUrls[0])} alt="Gallery Item" />
                    )}
                </div>
            )}
            {uniqueUrls.length > 1 && (
                <>
                    {link ? (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <CrossfadeImage
                                style={{ maxWidth: null, maxHeight: null }}
                                src={convertToDirectLink(uniqueUrls[currentIndex])}
                            />
                        </a>
                    ) : (
                        <CrossfadeImage
                            style={{ maxWidth: null, maxHeight: null }}
                            src={convertToDirectLink(uniqueUrls[currentIndex])}
                        />
                    )}
                    {captions && (
                        <div style={{ fontSize: '1rem', fontFamily: 'Flama-Medium',marginTop:13 }}>
                            {captionsParsed[currentIndex]}
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default function Game(props) {

    const gameConfig = props.data;

    const [navClickable, setNavClickable] = React.useState(false);

    const [levelJumpExecuted, setLevelJumpExecuted] = React.useState(false);

    const [currentLevel, setCurrentLevel] = React.useState(INIT_LEVEL);//0 = cooking, 1 = myplate
    const [currentStep, setCurrentStep] = React.useState(INIT_STEP);

    const [levelData, setLevelData] = React.useState(null);
    const [stepData, setStepData] = React.useState(null);

    const [navSections, setNavSections] = React.useState(null);

    const [game, setGame] = React.useState(null);

    const [preloading, setPreloading] = React.useState(false);

    const [isVideoModalOpen, setVideoModalOpen] = React.useState(false);

    const [isLearnMoreModalOpen, setLearnMoreModalOpen] = React.useState(false);

    const disableButtonsTemporarily = () => {
        // Add a CSS class to disable buttons
        document.body.classList.add('disable-buttons');

        // Re-enable buttons after 1 second
        setTimeout(() => {
            document.body.classList.remove('disable-buttons');
        }, 1000); // 1 second
    }

    const nextStep = (sectionIN,stepIN) => {

        disableButtonsTemporarily();

        console.log('nextStep: ', currentLevel, currentStep);

        let nextStep = currentStep + 1;
        let nextLevel = currentLevel + 1;

        if(sectionIN!==null && stepIN!=null){
            nextLevel = sectionIN;
            nextStep = stepIN;

        }

        //check the currentLevel views and if there is another step then increment the step
        let hasNextStep = levelData?.views?.length > nextStep;

        if (hasNextStep) {
            nextLevel = currentLevel;//since we are still on the same level
            setCurrentStep(nextStep);
        } else {
            nextStep = 0;
            //check the currentLevel and if there is another level then increment the level
            let hasNextLevel = gameConfig.sections.length > nextLevel;

            if (hasNextLevel) {
                setCurrentLevel(nextLevel);
                setCurrentStep(0);
            } else {
                console.log('no more levels');
                // setCurrentLevel(0);
                // setCurrentStep(0);
                //the game is done we want to start all over, so reload the page.
                window.location.reload();
            }
        }

        //setting the current step on the scene data
        //set current step data
        let newLevelData = gameConfig?.sections[nextLevel];
        let currentStepData = newLevelData?.views[nextStep];
        let currentLevelData = gameConfig?.sections[nextLevel];
        console.log('1. setting current step on scene data: ', nextLevel + ":" + nextStep);

        game.currentState = {
            currentLevel: nextLevel,
            currentLevelData: currentLevelData,
            currentStep: nextStep,
            currentStepData: currentStepData
        };

        //change the page title to the section title
        //document.title = currentLevelData.title;

        try {
            game.events.emit('changeStep', nextLevel, currentLevelData, nextStep, currentStepData);    
        } catch (error) {
            console.log('error: ', error);
        }
    }

    const prevStep = () => {
        disableButtonsTemporarily();

        let hasPrevStep = currentStep > 0;
        let prevLevl = currentLevel;

        let prevStep = 0;

        if (hasPrevStep) {
            prevStep = currentStep - 1;

            if (prevStep < 0)
                prevStep = 0;

            setCurrentStep(prevStep);
        } else {
            //check the currentLevel and if there is another level then increment the level
            let hasPrevLevel = currentLevel > 0;

            if (hasPrevLevel) {
                prevLevl = currentLevel - 1;
                if (prevLevl < 0)
                    prevLevl = 0;

                prevStep = gameConfig.sections[prevLevl].views.length - 1;
                setCurrentLevel(prevLevl);
                setCurrentStep(prevStep);
            }
        }

        let currentLevelData = gameConfig.sections[prevLevl];
        let currentStepData = currentLevelData.views[prevStep];
        console.log('2. setting current step on scene data: ', prevLevl + ":" + prevStep);

        game.currentState = {
            currentLevel: prevLevl,
            currentLevelData: currentLevelData,
            currentStep: prevStep,
            currentStepData: currentStepData
        };

        //change the page title to the section title
        //document.title = currentLevelData.title;

        game.events.emit('changeStep', prevLevl, currentLevelData, prevStep, currentStepData);
    }

    /**
     * This function reviews the slides and returns the step number for the slide index based on 
     * the navSection value of the slide and the position in the navSections array.
     * 
     * @param {*} slideIndex 
     */
    const getSectionIndexForCurrentStep = () => {
        //let ns = navSections;
        let navSection = levelData?.views[currentStep]?.navSection;
        let navSectionIndex = navSections.findIndex(ns => ns.name == navSection);

        // debugger;    
        return navSectionIndex;
    }

    //current level change event
    useEffect(() => {
        console.log('current level changed: ', currentLevel, gameConfig);

        let level = gameConfig.sections[currentLevel];

        setLevelData(level);
        //setCurrentStep(0);

        //set the nav sections, this is pulled from an attribute on the nav sections called navSection.
        //each section can have multiple nav sections
        let navSections = [];
        let navSectionsByName = {};
        level.views.forEach(view => {
            let navSectionName = view.navSection;
            if (navSectionName) {
                let navSection = navSectionsByName[navSectionName];
                if (!navSection) {
                    navSection = {
                        name: navSectionName,
                        steps: []
                    };
                    navSectionsByName[navSectionName] = navSection;
                    navSections.push(navSection);
                }

                navSection.steps.push(view);
            }
        });

        //sort the nav sections by the order they appear in the level
        setNavSections(navSections);

        //set the first step
        setStepData(level.views[currentLevel]);


    }, [currentLevel, gameConfig]);


    // current step change event
    useEffect(() => {
        
        console.log('current step changed: ', currentStep, stepData?.subSectionID);

        if (!game) {
            return;
        }

        if (levelData) {
            let step = levelData.views[currentStep];
            setStepData(step);
        }

        //if there is a query param called s in the format 0:0 then parse it and use the values as SECTION:STEP
        if (!levelJumpExecuted) {
            setLevelJumpExecuted(true);
            
            setTimeout(() => {  
                try {
                    const urlParams = new URLSearchParams(window.location.search);
                    const s = urlParams.get('s');
                    if (s) {
                        let parts = s.split(':');
                        if (parts.length == 2) {
                            let section = parseInt(parts[0]);
                            let step = parseInt(parts[1]);

                            setTimeout(() => {
                                window.skippingSteps = true;
                                nextStep(section, step);
                            }, 3000);


                            // if (!isNaN(section) && !isNaN(step)) {
                            //     //loop through and call nextStep until we get to the correct section and step
                            //     if (currentLevel !== section || currentStep !== step) {
                            //         while (currentLevel !== section || currentStep !== step) {
                            //             nextStep();
                            //         }
                            //     }
                            // }
                        }
                    }
                } catch (error) {
                    console.log('error: ', error);   
                }
            }, 3000);
        }


    }, [currentStep, levelData, levelJumpExecuted, game]);


    //get the #phaserGame div by id and then its parent parent and then get the width and height

    //setup scene order


    //for small screen, lets adjust the size
    const pixelRatio = window.devicePixelRatio || 1; // Get scaling factor (1 = 100%, 1.5 = 150%)

    const adjustedWidth = window.innerWidth;
    const adjustedHeight = window.innerHeight;

    // Detect if screen should be considered small
    const isSmallScreen = adjustedWidth <= 1080;

    let gameScale = isSmallScreen ? '140%' : '100%';

    // Specific case for 1366x768 resolution
    if (adjustedWidth == 1366 && adjustedHeight <= 768) {
        gameScale = '140%';
    }

    //scaling
    const baseWidth = 1450 + 350;//this is the base size of 1450 - 350 for the left column;
    const baseHeight = 863;
    const minScale = 0.5; // Minimum scale when width is 1450px or larger
    const maxScale = 1.5; // Maximum scale when width is much smaller

    // Inverse proportional scaling
    let scaleFactor = baseWidth / window.innerWidth;


    const gameScaledHeight = baseHeight * (scaleFactor-1);
    const topPadding = Math.max(0, gameScaledHeight - window.innerHeight);

    
    console.log('topdebug; gameScaledHeight: ', gameScaledHeight);
    console.log('topdebug; scaleFactor: ', scaleFactor);
    console.log('topdebug; topPadding: ', topPadding);
    console.log('topdebug; innerHeight: ', window.innerHeight);
    console.log('topdebug; gameScale: ', gameScale);
    console.log('topdebug; pixelRatio: ', pixelRatio);


    //set padding top of the game
    
    setTimeout(() => {
        document.getElementById('phaserGame').style.paddingTop = `${topPadding}px`;    
    }, 1000);


    //lets calculate the gameScale by the window.innerWidth
    //100% is a width of 1450px, if width >= 1450 then we use 100%
    //if its < 1450 then we calculate the percentage of the width and use that as the scale
    if (window.innerWidth < 1450) {
        //gameScale = `${(window.innerWidth / 1450) * 100}%`;
        // Apply it as a percentage
        gameScale = `${scaleFactor * 100}%`;
    }

    // gameScale = '240%';

    //debug gameScale
    console.log(`Scaling: ${gameScale}, Adjusted Width: ${adjustedWidth}, Adjusted Height: ${adjustedHeight}`);

    //gameScale = "110%";
    //load the phaser game
    //this will run once when the component is loaded
    useEffect(() => {
        //if browser size is smaller than 1080 (small screen) then we don't load the game and show a message
        // if (window.innerWidth < 1080) {
        //     alert('screen size is too small to load the game');
        //     return;
        // }



        //start phaser
        const config = {
            type: Phaser.AUTO,
            parent: "phaserGame",
            width: '100%',
            height: '100%',
            transparent: true,
            autoResize: true,
            scene: PHASER_SCENES,

            pixelArt:false,
            roundPixels: true,
            antialias: true,
            antialiasGL: true,

            resolution: window.devicePixelRatio,
            mipmapFilter: 'LINEAR_MIPMAP_LINEAR',


            scale: {
                mode: Phaser.Scale.ENVELOP,
                // mode: Phaser.Scale.FIT, // Automatically scale the game
                autoCenter: Phaser.Scale.BOTTOM_LEFT, // Align to bottom-left
                width: gameScale, // Use percentage to indicate dynamic resizing
                height: gameScale, // Use percentage for dynamic height adjustment

                // width: gameWidth * scaleFactor,
                // height: gameHeight * scaleFactor,
            },
            plugins: {
                scene: [
                    { key: "SpinePlugin", plugin: window.SpinePlugin, mapping: "spine" }
                ]
            },
            audio: {
                disableWebAudio: false
            },
            input: {
                activePointers: 1,
                maxPointers: 1
            }
        };
        const pgame = new Phaser.Game(config);
        setGame(pgame);
        window.pgame = pgame;



        let originalWidth = window.innerWidth; 
        let originalHeight = window.innerHeight; 

        /*window.addEventListener('resize', function (event) {
            pgame.canvas.width = window.innerWidth;
            pgame.canvas.height = window.innerHeight;


            pgame.scale.setGameSize(window.innerWidth, window.innerHeight);
            pgame.scale.displaySize.setAspectRatio(window.innerWidth / window.innerHeight);
            //also set setGameSize

            let activeScene = pgame.scene.getScenes(true)[0];

            // activeScene.input.on('pointerdown', (pointer) => {
            //     alert('Pointer down at:'+ pointer.x+"x"+pointer.y);
            // });

            activeScene.cameras.main.setSize(window.innerWidth, window.innerHeight);
            

            //scale the scene
            //activeScene.cameras.main.setZoom(0.5);
            //step zoom down
            //get the current zoom
            // Align the camera to the left
            activeScene.cameras.main.scrollX = 0;

            let currentWidth = activeScene.cameras.main.width;
            let currentHeight = activeScene.cameras.main.height;

            let zoomFactorWidth = currentWidth / originalWidth;
            let zoomFactorHeight = currentHeight / originalHeight;

            // Calculate zoom factor based on both width and height
            let zoomFactor = Math.min(zoomFactorWidth, zoomFactorHeight);

            //if the screen is small can we set the zoom to a smaller size so it fits
            // zoomFactor = 0.1;

            activeScene.cameras.main.setZoom(zoomFactor);

            // Adjust scrollX based on zoomFactor
            let speedFactor = 0.5; // Adjust this value to change the speed

            if (zoomFactor < 1) {
                // Move to the right
                activeScene.cameras.main.scrollX += (1 - zoomFactor) * originalWidth * speedFactor;
            } else if (zoomFactor > 1) {
                // Move to the left
                activeScene.cameras.main.scrollX -= (zoomFactor - 1) * originalWidth * speedFactor;
            }

            // Get the game world's height
            let worldHeight = originalHeight;

            // Adjust scrollY to keep the bottom of the view aligned with the bottom of the game world
            activeScene.cameras.main.scrollY = worldHeight - activeScene.cameras.main.displayHeight * zoomFactor;


            pgame.scale.refresh();
        });*/

        // pgame.scale.on('resize', resizeGame, this);

        // function resizeGame(gameSize, baseSize, displaySize, resolution) {
        //     // Assuming your game has a single scene, or you can adapt this logic for multiple scenes
        //     let scene = game.scene.scenes[0]; // Get the first scene; adjust accordingly if you have multiple scenes

        //     // Calculate the scale ratio
        //     let scaleRatio = Math.min(
        //         gameSize.width / scene.sys.game.config.width,
        //         gameSize.height / scene.sys.game.config.height
        //     );

        //     // Update the scale of the game's camera to fit the game within the new browser size
        //     scene.cameras.main.setZoom(scaleRatio);

        //     // If you have UI elements or other game objects that need to be repositioned, do it here
        //     // For example, reposition a UI element:
        //     // scene.yourUIElement.setPosition(newX * scaleRatio, newY * scaleRatio);
        // }

        // // Initial resize to ensure everything fits from the start
        // resizeGame(game.scale.gameSize, game.scale.baseSize, game.scale.displaySize, game.scale.resolution);

        //end phaser

        //load initial level
        setTimeout(() => {
            try {
                setCurrentLevel(null);
                setCurrentLevel(INIT_LEVEL);

                //set the current step
                setTimeout(() => {
                    setCurrentStep(null);
                    setCurrentStep(INIT_STEP);
                }, 100);
            } catch (error) {
                console.log('error: ', error);
                
            }
        }, 100);

        // window.addEventListener('resize', function () {
        //     // Call the resize method of the game's renderer
        //     pgame.renderer.resize(window.innerWidth, window.innerHeight);
        // });

        //init the currentState
        pgame.currentState = {
            currentLevel: INIT_LEVEL,
            currentLevelData: gameConfig.sections[INIT_LEVEL],
            currentStep: INIT_STEP,
            currentStepData: gameConfig.sections[INIT_LEVEL].views[INIT_STEP]
        };


        //Allow users to jump around - create special URL parameter to make categories clickable
        //if the URL has a hashtag called t then we will allow the user to click on the categories
        //for example https://localhost:3000/game#t
        var hash = window.location.hash;
        if (hash === '#t' || window.location.hostname === 'localhost') {
            setNavClickable(true);
        }

        pgame.events.on('phaserScenePreloadStart', (currentLevel, currentLevelData, currentStep, currentStepData) => {
            // alert('phaserScenePreloadStart');
            setPreloading(true);
        });

        pgame.events.on('phaserScenePreloadEnd', (currentLevel, currentLevelData, currentStep, currentStepData) => {
            //alert('phaserScenePreloadEnd');
            setPreloading(false);
        });

    }, []);

    const self = this;

    // debugger;
    //console.log('init: ', "levelData: ", levelData, "navSections: ", navSections, "game: ", game, "stepData: ", stepData);

    if (levelData == null || navSections == null || game == null || stepData == null) {
        return (
            <div></div>
        );
    }

    const topNavClicked = (navSection, index) => {
        if(!navClickable){
            return;
        }

        //set navClickable to false for 1s to prevent spamming
        setNavClickable(false);
        setTimeout(() => {
            setNavClickable(true);
        }, 2500);
        
        //skip to the 1st step of teh nav section
        //loop though all sections up to the index and count the steps
        let stepIndex = 0;
        for (let i = 0; i < index; i++) {
            stepIndex += navSections[i].steps.length;
        }

        nextStep(currentLevel, stepIndex);
    }

    const VideoModal = ({ isOpen, handleClose, children }) => {
        if (!isOpen) return null;

        return (
            <div onClick={handleClose} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                <div style={{ position: 'relative', padding: '0px', background: '#000', borderRadius: '8px', overflow: 'hidden' }}>
                    <a href='#' onClick={handleClose} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1001 }}>
                        <img src={closeBtn} alt='Close' />
                    </a>
                    {children}
                </div>
            </div>
        );
    }

    const InfoModal = ({ handleClose, children, title }) => {

        return (
            <div
                onClick={handleClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                    zIndex: 9999,
                }}
            >
                <div
                    onClick={(e) => e.stopPropagation()} // Prevents click propagation
                    style={{
                        position: 'relative',
                        background: '#FDD99D',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        zIndex: 10000,
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)',
                        maxWidth: '95vw',
                        maxHeight: '98vh',
                    }}
                >
                    {/* Modal Header with Title and Close Button */}
                    <div
                        style={{
                            position: 'sticky',
                            top: 0,
                            background: '#FDD99D',
                            padding: '5px 5px',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            zIndex: 10001,
                        }}
                    >
                        <span style={{paddingLeft:10}}>{title}</span>
                        <a
                            href="#"
                            onClick={handleClose}
                            style={{
                                textDecoration: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                            }}
                        >
                            <img src={closeBtn} alt="Close" style={{ cursor: 'pointer',height:40 }} />
                        </a>
                    </div>
                    {/* Modal Content */}
                    <div
                        style={{
                            overflowY: 'auto',
                            maxHeight: 'calc(95vh - 20px)', // Prevents content overflow
                            padding: '5px',
                            paddingBottom: '0', 
                            paddingTop: '0'
                        }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        );
    };




    /**
     * The game layout has two main sections with a 3 to 1 ration in size.
     * 1. The left section will have a top navigation that will show the steps (et. 1-5) 
     * for the current section (loaded form the data; myplate or activity). Under that will be the phaser game.
     * 2. The right column is small data column with a title, description, an image or video and the navigation (previous & next).
     */
    return (
        <>
            <Grid container style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
                {/* Left section */}
                <Grid item sm={9} style={{ height: '100%', padding: 0 }}>
                    {/* Top navigation - Assuming you want to keep the spacing here */}
                    <Grid className={navClickable ? 'pointer-events-enabled':''} container spacing={2} style={{ height: '100px', marginTop: 5, marginLeft: 5 }}> {/* Adjusted color for clarity */}
                        <div style={{ padding: '16px' }} className='step-nav-container'>
                            <div className='step-nav' >
                                {Array.from(navSections, (navSection, index) => (
                                    <>
                                        <div onClick={() => topNavClicked(navSection,index)} className="step-nav-box-background" key={index}>
                                            {/* Marker backgrounds */}

                                            {/* Markers backgrounds completed steps */}
                                            {getSectionIndexForCurrentStep() >= index && <>
                                                {index === 0 && <img src={stepBackgroundOnFirst} alt="" />}
                                                {index > 0 && index < (navSections.length - 1) && <img src={stepBackgroundOnMiddle} alt="" />}
                                                {index === (navSections.length - 1) && <img src={stepBackgroundOnLast} alt="" />}
                                             </>}

                                            {/* Non-Completed Steps */}
                                            {getSectionIndexForCurrentStep() < index && <>
                                                {index === 0 && <img src={stepBackgroundFirst} alt="" />}
                                                {index > 0 && index < (navSections.length - 1) && <img src={stepBackgroundMiddle} alt="" />}
                                                {index === (navSections.length - 1) && <img src={stepBackgroundLast} alt="" />}
                                            </>}
                                            <div className="step-nav-label">{navSection.name}
                                            </div>
                                        </div>
                                        
                                    </>
                                ))}
                            </div>
                        </div>

                    </Grid>


                    {/* Middle row - Phaser game */}
                    <Grid item style={{ height: '80%', width: '100%' }}>
                        {/* <div style={{ padding: '16px' }} ref={phaserGameDiv} id="phaserGame" style={{ height: '98%', width: '100%' }}></div> */}
                    </Grid>

                    {/* Bottom controls - volume/mute/etc */}
                    
                    <CustomAudioPlayer paused={preloading} audioUrl={convertToDirectLink(stepData?.voiceoverAudioClipUrl)} autoplay={true} audioTranscript={stepData?.voiceoverAudioTranscript} viewId={stepData?.viewId} />
                </Grid>

                {/* Right section */}
                <SlidingGrid>
                    <Grid className="content-column pointer-events-enabled" style={{ height: '100%', padding: 10, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: 1 }}> {/* Flex container for the content above the list */}
                            <h2 className='outlined-text'>{stepData?.sidebarTitle}</h2>
                            <p dangerouslySetInnerHTML={{__html:stepData?.sidebarCopy}}></p>

                            
                            
                            {stepData?.assetType === 'youtube' ? (
                                // render youtube video container
                                <div class="video-container" onClick={()=>{
                                    setVideoModalOpen(true)
                                    window.gameBackgroundMusicPaused = true;
                                }}><iframe style={{ pointerEvents: 'none' }} src={stepData?.assetURL} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen sandbox="allow-same-origin allow-scripts allow-presentation"></iframe></div>
                            ) : (
                                // render image

                                    <div className="image-gallery-container-parent">
                                    <div className="image-gallery-container">
                                        <div className="image-gallery">
                                                <ImageGallery link={stepData.assetLink} urls={stepData.assetURL} captions={stepData.assetURLCaptions} />
                                        </div>
                                    </div>
                                </div>
                                    // stepData?.assetURL && <img className={stepData?.assetDropShadow === false ? '' : 'image-drop-shadow'} width={'90%'} src={convertToDirectLink(stepData?.assetURL)} key={convertToDirectLink(stepData?.assetURL)} alt={stepData?.sidebarTitle} />
                            )}

                            {/* if we have a assetURL2 render as image */}
                            {stepData?.assetURL2 && <img onClick={() => {
                                //if there is a assetURLAction and its value is reset then lets start over
                                if (stepData?.assetURLAction && stepData?.assetURLAction === 'reset') {
                                    setCurrentLevel(0);
                                    setCurrentStep(0);
                                }
                            }} data-type="assetURL2" className={stepData?.asset2DropShadow === false ? '' : 'image-drop-shadow'} style={{marginTop:15}} width={stepData?.assetURL2Width ? stepData?.assetURL2Width:null} src={convertToDirectLink(stepData?.assetURL2)} key={convertToDirectLink(stepData?.assetURL2)} alt='callout' />}

                            {/* if we have a assetURL3 render as image */}

                            {stepData?.learnMore && <a href="#" style={{display:'block', marginBottom: 40 }} onClick={() => { 
                                //pause the audio
                                if (stepData?.learnMoreHasAudio) {
                                window.gameBackgroundMusicPaused = true;
                                }

                                setLearnMoreModalOpen(true); 
                            }}>Learn More</a>}

                            


                            <VideoModal isOpen={isVideoModalOpen} handleClose={() => {
                                setVideoModalOpen(false);
                                window.gameBackgroundMusicPaused = false;
                            }}>
                                <div style={{
                                    position: 'relative',
                                    width: '80vw',
                                    paddingTop: '45%', /* for 16:9 aspect ratio */
                                    overflow: 'hidden',
                                }}>
                                    <iframe
                                        src={`${stepData?.assetURL}?autoplay=1`}
                                        title="Responsive Content"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%', // Ensures the iframe fills the parent width
                                            height: '100%', // Ensures the iframe respects the aspect ratio
                                        }}
                                        sandbox="allow-same-origin allow-scripts allow-presentation"
                                    ></iframe>
                                </div>
                            </VideoModal>

                            {stepData?.postAssetContent && <p dangerouslySetInnerHTML={{ __html: stepData?.postAssetContent }}></p>}
                        </div>

                        {/* Navigation */}
                        <div className='navigation-buttons'>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', justifyContent: 'center' }}>
                                <li style={{ marginRight: '40px' }}>
                                    <CustomIconButton
                                    onClick={prevStep}
                                    style={{
                                        border: 'none',
                                        background: 'none',
                                        cursor: 'pointer',
                                        pointerEvents: (currentStep === 0 && currentLevel === 0) ? 'none' : 'auto'
                                    }}
                                    disabled={currentStep === 0 && currentLevel === 0}
                                    color="primary"
                                >
                                    <img
                                        width={80}
                                        src={leftNavBtn}
                                        alt="Previous"
                                        style={{
                                            opacity: (currentStep === 0 && currentLevel === 0) ? '50%' : '100%'
                                        }}
                                    />
                                </CustomIconButton>
                            </li>
                            <li>
                                <CustomIconButton onClick={nextStep} style={{ border: 'none', background: 'none', cursor: 'pointer' }} color="primary">
                                    <img width={80} src={rightNavBtn} alt="Next" />
                                </CustomIconButton>
                            </li>
                        </ul>
                        </div>
                    </Grid>
                </SlidingGrid>
            </Grid>

            {/* preload overlay */}
            {preloading && <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, pointerEvents: 'auto' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div class="loading-spinner"></div>
                </div>
            </div>}

            {/* Learn more modal */}
            <Popper id={stepData?.learnMoreTitle} open={isLearnMoreModalOpen} style={{ zIndex: 2000 }} >
            <InfoModal
                handleClose={() => {
                    setLearnMoreModalOpen(false);
                    window.gameBackgroundMusicPaused = false;
                }}
                title={stepData?.learnMoreTitle}
            >
                <div style={{ width: '100%', height: '100%' }}>
                    <iframe
                        src={stepData?.learnMore}
                        style={{
                            width: '85vw',
                            height: '90vh',
                            border: 'none',
                            display: 'block'
                        }}
                        title="Learn More"
                        sandbox="allow-same-origin allow-scripts allow-presentation"
                    />
                </div>
            </InfoModal>
            </Popper>
        </>
    );
}


